import React, { useState, useEffect } from 'react';

import { APP_URL } from 'types';
import { SideNavLink } from 'carbon-components-react/lib/components/UIShell';
import { UserMultiple16, Report16 } from '@carbon/icons-react';
import { useHistory } from 'react-router-dom';

export const LeftNavCommonMenuItem: React.FC<Props> = ({ disableNav }) => {
  const history = useHistory();
  const [pathname, setPathname] = useState<string>(history?.location?.pathname);

  const queryParams = new URLSearchParams(history?.location?.search);
  const preview = queryParams.get('preview');
  useEffect(() => {
    history && setPathname(history.location?.pathname);
  }, [history]);
  return (
    <>
      <SideNavLink
        aria-disabled={disableNav}
        aria-current={
          pathname === APP_URL.USERS || `/${preview}` === APP_URL.USERS
            ? 'page'
            : undefined
        }
        renderIcon={UserMultiple16}
        onClick={
          disableNav ? undefined : () => history.push(`${APP_URL.USERS}`)
        }
      >
        Users
      </SideNavLink>
      <SideNavLink
        aria-disabled={disableNav}
        aria-current={
          pathname === APP_URL.REPORTING || `/${preview}` === APP_URL.REPORTING
            ? 'page'
            : undefined
        }
        renderIcon={Report16}
        onClick={
          disableNav ? undefined : () => history.push(`${APP_URL.REPORTING}`)
        }
      >
        Reporting
      </SideNavLink>
    </>
  );
};

type Props = {
  disableNav?: boolean;
};

export default LeftNavCommonMenuItem;
